import { LogTag, Logger, ServiceType } from "@lib/monitoring/logger";

export const to = <T>(promise: Promise<T>): Promise<{ error: Error | null; data: T | null }> =>
    promise
        .then((data: T) => ({ error: null, data }))
        .catch((error: Error) => {
            Logger.error(ServiceType.NEXT_API, "Error occurred during promise execution", {
                tag: LogTag.ERROR,
                error,
            });

            return { error, data: null };
        });
